<ng-container *ngIf="!init; else showFilePicker">
  <mat-spinner color="primary" diameter="24"></mat-spinner>
</ng-container>

<ng-template #showFilePicker>
  <div class="upper-space">
    <file-picker
      [offlineUpload]="true"
      [emitOfflineAssets]="true"
      [uploadButtonLabel]="'Foto toevoegen'"
      [disabled]="disabled"
      (assetsAdded)="onAssetsAdded($event)"
    >
    </file-picker>

    <div
      class="double-less-upper-space"
      [class.d-flex]="flexImages"
      *ngIf="toShowAssets?.length > 0"
    >
      <div *ngFor="let asset of toShowAssets; index as i">
        <div class="d-flex">
          <div class="secondary-color">
            {{ asset.name | shortenTextSplitOn : '.' : 10 }}
          </div>

          <mat-icon
            class="clickable align-delete-icon secondary-color"
            aria-hidden="false"
            aria-label="remove"
            (click)="removeAsset(asset, i)"
          >
            delete
          </mat-icon>
        </div>

        <div>
          <img
            *ngIf="isImage(asset)"
            class="max-img-width max-img-height"
            [src]="asset.uuid | assetSource : asset.localSafeUrl"
          />
        </div>
      </div>
    </div>
  </div>
</ng-template>
